import { parseJSONData } from '../lib/json.ts'
import { type QuestionnaireAnswers } from '../questionnaires/types.ts'
import { type PropertyFiltersType } from './filterTypes.ts'
import {
  type ParsedInterest,
  type RawInterest,
  type ReadinessValue,
  propertyInterestDataSchema,
} from './types.ts'

function isValidReadinessValue(value: number | null): value is ReadinessValue {
  return value === 0 || value === 0.3 || value === 0.6 || value === 0.8 || value === 1
}

export function getReadinessFromAnswers(
  answers: QuestionnaireAnswers | null | undefined
): ReadinessValue | null {
  if (!Array.isArray(answers) || answers.length === 0) {
    return null
  }

  const timingEntry = answers.find((answer) => answer.id === 'timing')
  const value = typeof timingEntry?.value === 'number' ? timingEntry.value : null

  return isValidReadinessValue(value) ? value : null
}

export function createParsedInterest(interest: RawInterest): ParsedInterest | null {
  const parsedData = parseJSONData(interest.data, propertyInterestDataSchema)

  if (!parsedData) {
    console.log('Error parsing interest data:', interest)
    return null
  }

  return {
    ...interest,
    data: {
      ...parsedData,
      filters: parsedData.filters as PropertyFiltersType,
    },
    created_at: new Date(interest.created_at),
    updated_at: interest.updated_at ? new Date(interest.updated_at) : null,
    verified_at: interest.verified_at ? new Date(interest.verified_at) : null,
    deleted_at: interest.deleted_at ? new Date(interest.deleted_at) : null,
  } satisfies ParsedInterest
}

export function createParsedInterests(interests: RawInterest[]) {
  return interests.map(createParsedInterest).filter((interest) => interest !== null)
}
